package ar.corzo.firebase

import ar.corzo.firebase.npm.collection
import ar.corzo.firebase.npm.doc
import ar.corzo.firebase.npm.firestore
import ar.corzo.firebase.npm.getDoc
import ar.corzo.firebase.npm.mapOf
import ar.corzo.health_tracker.types.firebase.FireStoreFilter
import ar.corzo.health_tracker.utils.asMap
import kotlinx.coroutines.await


actual suspend fun getDoc(path: String): Map<String, Any>? {
    val ref = doc(firestore(), path)
    val snapshot = getDoc(ref).await()
    return if(snapshot.exists())
        mapOf(snapshot.data())?.asMap()
    else null
}

actual suspend fun deleteDoc(path: String): Boolean {
    TODO()
    /*val ref = doc(firestore(), path)
    return try {
        deleteDoc(ref).await()
        true
    } catch (e: Throwable) {
        false
    }*/
}

actual suspend fun getDocs(
    col: String,
    query: Set<FireStoreFilter>,
    limit: Int?
): Map<String, Map<String, Any>>? {
    // Por ahora no hay query implementado, solo getAll
    val ref = collection(firestore(), col)
    // Falta implementar soporte para query y limit, requiere bindings a where, limit, getDocs, etc.
    return emptyMap()
}

actual suspend fun addDoc(
    col: String,
    data: Map<String, Any>
): String? {
    TODO()
    /*val ref = collection(firestore(), col)
    return try {
        val result = addDoc(ref, data.toJsObject()).await()
        result.id
    } catch (e: Throwable) {
        null
    }*/
}

actual suspend fun setDoc(
    path: String,
    data: Map<String, Any>
): Boolean {
    TODO()
    /*val ref = doc(firestore(), path)
    return try {
        val jsData = data.toJsObject()
        setDoc(ref, jsData)
        true
    } catch (e: Throwable) {
        false
    }*/
}

actual suspend fun updateDoc(
    path: String,
    data: Map<String, Any>
): Boolean {
    TODO()
    /*val ref = doc(firestore(), path)
    return try {
        val jsData = data.toJsObject()
        updateDoc(ref, jsData).await<Nothing>()
        true
    } catch (e: Throwable) {
        false
    }*/
}
